define(["exports", "text!../../assets/var.css", "./pubsubhub"], function (_exports, _var, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _var = _interopRequireDefault(_var);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  // @ts-check

  /**
   * Module core/highlight-vars
   * Highlights occurrences of a <var> within a section on click.
   * Set `conf.highlightVars = true` to enable.
   * Removes highlights from <var> if clicked anywhere else.
   * All is done while keeping in mind that exported html stays clean
   * on export.
   */
  const name = "core/highlight-vars";
  _exports.name = name;

  function run(conf) {
    if (!conf.highlightVars) {
      return;
    }

    const styleElement = document.createElement("style");
    styleElement.textContent = _var.default;
    styleElement.classList.add("removeOnSave");
    document.head.appendChild(styleElement);
    document.querySelectorAll("var").forEach(varElem => varElem.addEventListener("click", highlightListener)); // remove highlights, cleanup empty class/style attributes

    (0, _pubsubhub.sub)("beforesave", outputDoc => {
      outputDoc.querySelectorAll("var.respec-hl").forEach(removeHighlight);
    });
  }

  function highlightListener(ev) {
    ev.stopPropagation();
    const {
      target: varElem
    } = ev;
    const hightligtedElems = highlightVars(varElem);

    const resetListener = () => {
      const hlColor = getHighlightColor(varElem);
      hightligtedElems.forEach(el => removeHighlight(el, hlColor));
      [...HL_COLORS.keys()].forEach(key => HL_COLORS.set(key, true));
    };

    if (hightligtedElems.length) {
      document.body.addEventListener("click", resetListener, {
        once: true
      });
    }
  } // availability of highlight colors. colors from var.css


  const HL_COLORS = new Map([["respec-hl-c1", true], ["respec-hl-c2", true], ["respec-hl-c3", true], ["respec-hl-c4", true], ["respec-hl-c5", true], ["respec-hl-c6", true], ["respec-hl-c7", true]]);

  function getHighlightColor(target) {
    // return current colors if applicable
    const {
      value
    } = target.classList;
    const re = /respec-hl-\w+/;
    const activeClass = re.test(value) && value.match(re);
    if (activeClass) return activeClass[0]; // first color preference

    if (HL_COLORS.get("respec-hl-c1") === true) return "respec-hl-c1"; // otherwise get some other available color

    return [...HL_COLORS.keys()].find(c => HL_COLORS.get(c)) || "respec-hl-c1";
  }

  function highlightVars(varElem) {
    const textContent = varElem.textContent.trim();
    const parent = varElem.closest("section");
    const highlightColor = getHighlightColor(varElem);
    const varsToHighlight = [...parent.querySelectorAll("var")].filter(el => el.textContent.trim() === textContent && el.closest("section") === parent); // update availability of highlight color

    const colorStatus = varsToHighlight[0].classList.contains("respec-hl");
    HL_COLORS.set(highlightColor, colorStatus); // highlight vars

    if (colorStatus) {
      varsToHighlight.forEach(el => removeHighlight(el, highlightColor));
      return [];
    } else {
      varsToHighlight.forEach(el => addHighlight(el, highlightColor));
    }

    return varsToHighlight;
  }

  function removeHighlight(el, highlightColor) {
    el.classList.remove("respec-hl", highlightColor); // clean up empty class attributes so they don't come in export

    if (!el.classList.length) el.removeAttribute("class");
  }

  function addHighlight(elem, highlightColor) {
    elem.classList.add("respec-hl", highlightColor);
  }
});
//# sourceMappingURL=highlight-vars.js.map